import React from 'react';
import { motion } from 'framer-motion';
import { IMAGES, VIDEO_URL } from '../data/content';
export function VideoSection() {
  return <section className="bg-fil-rose-light px-4 sm:px-6 lg:px-8 py-12 sm:py-16 flex justify-center" data-id="element-213" data-mp="18vrtj0s612tc">
      <motion.div initial={{
      opacity: 0,
      y: 16
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.3,
      ease: [0.23, 1, 0.32, 1]
    }} className="w-full max-w-[300px] sm:max-w-[340px]" data-id="element-214" data-mp="1nt2dyzmsdj17">
        <div className="rounded-[2rem] overflow-hidden bg-white border-[6px] border-white shadow-lg aspect-[9/16]" data-id="element-215" data-mp="1rs1i4i0p1brl">
          {VIDEO_URL ? <video src={VIDEO_URL} autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-216" data-mp="26h7c9rkocbsm" /> : <img src={IMAGES.flores} alt="Flor de loto en filigrana de papel realizada a mano" className="w-full h-full object-cover" data-id="element-217" data-mp="21jnzkw3mk72s" />}
        </div>
      </motion.div>
    </section>;
}